import apiClient from '../apiClient';
import type { BaseResponse, PaginationRequest, ListResponse } from '../../types/base.dto';
import type { OrderData } from '../../types/process/order-data';
import type { InstallmentDetail } from '../../types/process/installment-detail';

export interface RepaymentLedgerJoined {
  installmentDetail: InstallmentDetail;
  orderData?: OrderData;
  /** 首期实际支付日期（优先 settlementTime，回退 actualPaymentDate） */
  firstPeriodPayDate?: string;
  /** 当期计算时间与首期支付的差异天数（仅支付完成时有值） */
  daysFromFirstPay?: number;
  /** 是否预收租金（periodNumber > 1 且 daysFromFirstPay ∈ [0, 10]） */
  isPrepaidRent?: boolean;
}

export type InstallmentLedgerListRequest = PaginationRequest;

export interface InstallmentLedgerSummary {
  totalCount: number;
  billAmountTotal: number;
  actualPaymentTotal: number;
  cashflowReceivedTotal: number;
  settlementRentTotal: number;
  paymentDiscountTotal: number;
  overdueHandledAmountTotal: number;
}

export class InstallmentAPI {
  /**
   * 获取分期账单明细列表
   * 对应后端路由: POST /installments/joined-list
   */
  async getInstallmentLedgerList(params: InstallmentLedgerListRequest): Promise<BaseResponse<ListResponse<RepaymentLedgerJoined>>> {
    const response = await apiClient.post('/installments/joined-list', params, { timeout: 100000 });
    return response.data;
  }

  async getInstallmentLedgerSummary(params: InstallmentLedgerListRequest): Promise<BaseResponse<InstallmentLedgerSummary>> {
    const response = await apiClient.post('/installments/joined-summary', params, { timeout: 100000 });
    return response.data;
  }
}

export const installmentApi = new InstallmentAPI();

export default installmentApi;
